import React, { useRef, useEffect } from 'react';

// PropTypes
import PropTypes from 'prop-types';

// React Router Dom
import { Link } from 'react-router-dom';

// Mui Joy Components
import Divider from '@mui/joy/Divider';

// Local Components
import Separator from '../FormFields/Separator';
import VenueCard from '../Cards/VenueCard';

// Typography
import { H4, Body2 } from '../../themes/typography';

// Icons
import { LeftIcon, RightIcon } from '../../icons/FontAwesomeIcon';

// CSS Styles
import '../../styles/components/VenueListCarousel.css';

export default function VenueListCarousel({
    venueCategory = 'Food & Drinks',
    seeAllList = '/',
    venueLists = <VenueCard />,
    showSeparator = true
}) {
    const scrollContainerRef = useRef(null);

    function scrollToLeft() {
        scrollContainerRef.current.scrollBy({ left: -500, behavior: 'smooth' });
    }

    function scrollToRight() {
        scrollContainerRef.current.scrollBy({ left: 500, behavior: 'smooth' });
    }

    // Prevent vertical scrolling when scrolling horizontally using mouse wheel event on the scroll container
    useEffect(() => {
        function handleWheel(event) {
            if (event.deltaY !== 0) {
                scrollContainerRef.current.scrollBy({ left: event.deltaY, behavior: 'smooth' });
                event.preventDefault(); // Prevent vertical scrolling when scrolling horizontally
            }
        }

        const scrollContainer = scrollContainerRef.current;
        scrollContainer.addEventListener('wheel', handleWheel);

        return () => {
            scrollContainer.removeEventListener('wheel', handleWheel);
        };
    }, []);

    return (
        <React.Fragment>
            <div className="venue-category-carousel-container">
                <div className="carousel-title-navigation">
                    <div className="category-title-and-separator">
                        <H4 color="#26C1E8">{venueCategory}</H4>
                        {/* <Separator /> */}
                    </div>

                    <div className="carousel-navigation">
                        <div className="carousel-left-navigation" onClick={scrollToLeft}>
                            <LeftIcon />
                        </div>
                        <div className="carousel-right-navigation" onClick={scrollToRight}>
                            <RightIcon />
                        </div>
                    </div>
                </div>

                <div className="venues-listing-container">
                    <div className="venues-list-container" ref={scrollContainerRef}>
                        {/* {Array.from({ length: 6 }).map((_, index) => (
                            <div key={index}>
                                <VenueCard />
                            </div>
                        ))} */}
                        {venueLists}
                    </div>
                    <div className="see-all-link">
                        <Link to={seeAllList}>
                            <button>
                                <Body2>See All</Body2>
                            </button>
                        </Link>
                    </div>
                </div>

                {/* Separator */}
                {showSeparator && (
                    <div className="separator-line">
                        <Divider sx={{ backgroundColor: 'rgba(223, 223, 223, 0.28)' }} />
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}

// PropTypes
VenueListCarousel.propTypes = {
    venueCategory: PropTypes.string,
    seeAllList: PropTypes.string,
    venueLists: PropTypes.array,
    showSeparator: PropTypes.bool
};
